import { Button, Flex, Typography } from "antd"

export const ProjectsStepUi = () => {
  return (
    <>
      <Typography.Text>
        To start using the cryptocurrency payment service—whether via API
        integration, <b>HTML iFrame</b>, or a simple payment link—you must first
        create a Project. When setting up a Project, you can:
      </Typography.Text>

      <ul>
        <li>Select the cryptocurrencies available for your customers.</li>
        <li>Choose a payment page theme (light or dark).</li>
        <li>Upload a logo and an image to customize the payment page.</li>
        <li>Specify a Callback URL to receive payment status updates.</li>
        <li>
          Set a Return URL to redirect customers after payment completion.
        </li>
      </ul>

      <Typography.Text>
        If you manage multiple businesses, you can create a separate Project for
        each one.{" "}
      </Typography.Text>
    </>
  )
}
